export const riskProfileColorCodes = {
    high: '#BE0C0C',
    medium: '#d96a07',
    low: '#7d7d7d',
}